import React from 'react';
import { Calendar, Ship } from 'lucide-react';

export default function ScheduleConfigSection({ config, onChange }) {
  const handleChange = (field, value) => {
    onChange({
      ...config,
      [field]: value
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-2 mb-4">
        <Calendar className="text-green-600" size={24} />
        <h2 className="text-xl font-semibold text-gray-900">Calendrier des Départs</h2>
      </div>
      
      <p className="text-gray-600 text-sm mb-6">
        Configurez les informations sur les prochains départs que Fatou communiquera aux clients.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Prochain Départ
          </label>
          <input
            type="date"
            value={config?.nextDeparture || ''}
            onChange={(e) => handleChange('nextDeparture', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Arrivée Estimée
          </label>
          <input
            type="date"
            value={config?.estimatedArrival || ''}
            onChange={(e) => handleChange('estimatedArrival', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Ship size={16} className="inline mr-1" />
            Nom du Navire
          </label>
          <input
            type="text"
            value={config?.vessel || ''}
            onChange={(e) => handleChange('vessel', e?.target?.value)}
            placeholder="Ex: MSC MEDITERRANEAN"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Durée de Transit (jours)
          </label>
          <input
            type="number"
            value={config?.transitDays || ''}
            onChange={(e) => handleChange('transitDays', e?.target?.value)}
            placeholder="14"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Port de Départ
          </label>
          <select
            value={config?.departurePort || 'Le Havre'}
            onChange={(e) => handleChange('departurePort', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          >
            <option value="Le Havre">Le Havre</option>
            <option value="Anvers">Anvers</option>
            <option value="Le Havre/Anvers">Le Havre/Anvers</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Port d'Arrivée
          </label>
          <input
            type="text"
            value={config?.arrivalPort || 'Abidjan'}
            onChange={(e) => handleChange('arrivalPort', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
          />
        </div>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-6">
        <p className="text-sm text-yellow-800">
          <strong>Important:</strong> Mettez à jour ces informations régulièrement pour que Fatou donne des informations précises aux clients.
        </p>
      </div>
    </div>
  );
}